import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, trackEvent } from '../utils/analytics.js';

/**
 * Hook personnalisé pour suivre automatiquement les vues de pages et les changements d'onglets
 *
 * @param {Object} options - Options de configuration
 * @param {Object} options.currentUser - L'utilisateur connecté (facultatif)
 * @param {Object} options.report - Le rapport actuel (facultatif)
 */
export default function useAnalytics(options = {}) {
  const location = useLocation();
  const { pathname } = location;
  const { currentUser, report } = options;

  // Suivi des changements de pages (sans le hash)
  useEffect(() => {
    let props = {};

    // Ajouter les infos d'utilisateur si disponibles
    if (currentUser) {
      props = {
        ...props,
        user: currentUser.username,
        client: currentUser.client,
        isAdmin: currentUser.isadmin || currentUser.issuperadmin
      };
    }

    // Effectuer le tracking de la page vue
    trackPageview({
      url: pathname,
    }, { props });
  }, [pathname, currentUser]);

  const track = (eventName, props) => {

    if (currentUser) {
      props = {
        ...props,
        user: currentUser?.username,
        client: currentUser?.client,
      };
    }

    if (report) {
      props = {
        ...props,
        cockpit: report?.client,
        week: `${report?.year}-${report?.week_number}`,
      };
    }

    trackEvent(eventName, { props });
  };

  // Pas besoin de retourner quoi que ce soit, le hook s'occupe du tracking en arrière-plan
  return { track };
}